/**
 * Rapi Bundles Variant Fix v2
 *
 * Rapi siempre envia el primer variant ID (Big Dog) ignorando
 * la seleccion del cliente. Este script intercepta el fetch de
 * /cart/add y sustituye cada item.id por el variant correcto
 * segun lo que el cliente tiene seleccionado en cada slot.
 *
 * Selectores confirmados por inspeccion del DOM:
 *   class: rapi-bundles__bar-variant-select
 *   data-variantname: "Design"
 */
(function () {

  // Mapa de nombre de variante -> variant ID de Shopify
  // Se construye desde el JSON que Shopify inyecta en la pagina
  function buildVariantMap() {
    try {
      var el = document.querySelector('variant-selects script[type="application/json"]');
      if (!el) return {};
      var variants = JSON.parse(el.textContent);
      var map = {};
      variants.forEach(function (v) {
        // Guardamos por option1 en minusculas para comparacion robusta
        map[v.option1.toLowerCase().trim()] = v.id;
      });
      return map;
    } catch (e) {
      return {};
    }
  }

  // Lee los selectores de la oferta actualmente seleccionada en Rapi
  // Rapi marca la oferta activa con un input radio checked dentro de .rapi-bundles__bar
  function getSelectedVariantIds(variantMap) {
    // Encuentra la oferta activa: el .rapi-bundles__bar que tiene el radio checked
    var allBars = document.querySelectorAll('.rapi-bundles__bar');
    var activeBar = null;

    allBars.forEach(function (bar) {
      var radio = bar.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        activeBar = bar;
      }
    });

    if (!activeBar) {
      // Fallback: coger la primera barra visible
      activeBar = document.querySelector('.rapi-bundles__bar');
    }

    if (!activeBar) return null;

    // Leer todos los selectores de variante dentro de esa oferta
    var selects = activeBar.querySelectorAll('.rapi-bundles__bar-variant-select');
    if (!selects || selects.length === 0) return null;

    var ids = [];
    selects.forEach(function (sel) {
      var val = (sel.value || '').toLowerCase().trim();
      var variantId = variantMap[val];
      if (variantId) {
        ids.push(variantId);
      }
    });

    return ids.length > 0 ? ids : null;
  }

  // Intercepta window.fetch
  var originalFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');

    if (url.indexOf('/cart/add') !== -1 && init && init.body) {
      try {
        var variantMap = buildVariantMap();
        var hasVariants = Object.keys(variantMap).length > 0;

        if (hasVariants) {
          var body = init.body;
          var selectedIds = getSelectedVariantIds(variantMap);

          if (selectedIds && selectedIds.length > 0) {

            // --- Caso 1: body es string JSON ---
            if (typeof body === 'string') {
              try {
                var parsed = JSON.parse(body);

                if (parsed.items && Array.isArray(parsed.items)) {
                  // Multi-item (bundle con varios slots)
                  var changed = false;
                  parsed.items.forEach(function (item, i) {
                    var correctId = selectedIds[i] || selectedIds[selectedIds.length - 1];
                    if (correctId && String(item.id) !== String(correctId)) {
                      console.log('[rapi-fix] item[' + i + '] ' + item.id + ' -> ' + correctId);
                      item.id = correctId;
                      changed = true;
                    }
                  });
                  if (changed) {
                    init = Object.assign({}, init, { body: JSON.stringify(parsed) });
                  }

                } else if (parsed.id) {
                  // Single item
                  var correctId = selectedIds[0];
                  if (correctId && String(parsed.id) !== String(correctId)) {
                    console.log('[rapi-fix] single item ' + parsed.id + ' -> ' + correctId);
                    parsed.id = correctId;
                    init = Object.assign({}, init, { body: JSON.stringify(parsed) });
                  }
                }
              } catch (e) {}
            }

            // --- Caso 2: body es FormData ---
            if (body instanceof FormData) {
              var itemsRaw = body.get('items');
              if (itemsRaw) {
                try {
                  var parsedItems = JSON.parse(itemsRaw);
                  var changed = false;
                  parsedItems.forEach(function (item, i) {
                    var correctId = selectedIds[i] || selectedIds[selectedIds.length - 1];
                    if (correctId && String(item.id) !== String(correctId)) {
                      console.log('[rapi-fix] FormData item[' + i + '] ' + item.id + ' -> ' + correctId);
                      item.id = correctId;
                      changed = true;
                    }
                  });
                  if (changed) {
                    body.set('items', JSON.stringify(parsedItems));
                  }
                } catch (e) {}
              } else {
                var singleId = body.get('id');
                if (singleId) {
                  var correctId = selectedIds[0];
                  if (correctId && String(singleId) !== String(correctId)) {
                    console.log('[rapi-fix] FormData single ' + singleId + ' -> ' + correctId);
                    body.set('id', String(correctId));
                  }
                }
              }
            }

          }
        }
      } catch (e) {
        console.warn('[rapi-variant-fix] error:', e);
      }
    }

    return originalFetch.call(this, input, init);
  };

  console.log('[PawLocket] rapi-variant-fix v2 loaded. Variant map:', buildVariantMap());

})();
